import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute ,Router} from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { sessionStorage } from 'src/app/localstorage.service';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';

@Component({
  selector: 'app-update-kyc',
  templateUrl: './update-kyc.component.html'
})
export class UpdateKycComponent implements OnInit {
  userData: any;
  userId: any;
  userName: any;
  data:any ={};
  savingFlag:boolean = false;
  assign_login_data:any={};
  logined_user_data:any={};
  kyc_id:any;
  Type:any;
  userDetails: any={};
  influencer_id:any;

  influencerUser:any=[];
  filter:any={}
  influencer_type:any;

  constructor(@Inject(MAT_DIALOG_DATA)public modelData, public dialogs: MatDialog, public toast:ToastrManager,  public session: sessionStorage, public ActivatedRoute : ActivatedRoute , public service : DatabaseService , public route :  Router, public dialogRef: MatDialogRef<UpdateKycComponent>,public alert : DialogComponent,public rout:Router,) { 
   this.kyc_id = modelData.kyc_id;
   this.Type = modelData.form_user_Item;
   if(this.Type=='change_user_type'){
   this.getInfluencerType();
   this.influencer_type=modelData.influencer_type
    this.data.change_usertype=modelData.influencer_type
   this.influencer_id = modelData.influencer_id;
   }
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    this.assign_login_data = this.session.getSession();
    this.logined_user_data = this.assign_login_data.value.data;
  }
  
  
  ngOnInit() {
  }




  submitDetail() {
    this.savingFlag = true;
    this.data.created_by_id = this.logined_user_data.id;
    this.data.created_by_name = this.logined_user_data.name;
    this.data.id = this.kyc_id;
    this.service.post_rqst( {'data':this.data,}, 'Influencer/updateKycStatus').subscribe((resp)=>
    {
      if (resp['statusCode'] == 200) {
        this.toast.successToastr('KYC Successfully Updated');
        this.savingFlag = false;
        this.dialogRef.close(true);
      }
      else{
        this.toast.errorToastr(resp['statusMsg']);
        this.savingFlag = false;
      }
    });
  }

  submitUserTypeDetail() {

    this.alert.confirm('Are you sure ?').then((result) => {
      if (result) {
        this.savingFlag = true;
        this.service.post_rqst( {'influencer_type':this.data.change_usertype,'influencer_id':this.influencer_id}, 'Influencer/changeUserType').subscribe((resp)=>
        {
          if (resp['statusCode'] == 200) {
            this.savingFlag = false;
            this.toast.successToastr('Change Usertype Successfully Updated');
            this.dialogRef.close(true);
            if(this.data.change_usertype=='Electrician'){
              this.rout.navigate(['influencer/16/'+this.data.change_usertype]);
            }
           else if(this.data.change_usertype=='Plumber'){
              this.rout.navigate(['influencer/8/'+this.data.change_usertype]);
            }
            else if(this.data.change_usertype=='Retailer ( Counter boy)'){
              this.rout.navigate(['influencer/17/'+this.data.change_usertype]);
            }


          }
          else{
            this.toast.errorToastr(resp['statusMsg']);
            this.savingFlag = false;
          }
        });

      }
    });


  }
  getInfluencerType()
    {
      this.filter.scanning_rights = 'Yes';
      this.service.post_rqst({'filter':this.filter},'Bonus/influencerMasterList').subscribe((result)=>
      {
        if (result['statusCode'] == 200){
          this.influencerUser=result['result'];
        }
        else{
          this.toast.errorToastr(result['statusMsg']);
        }
      })
    }
  
}
